// Promotional Content Types
export interface PromotionalContent {
  id: string;
  entity_type: EntityType;
  entity_type_display: string;
  entity_id: string;
  organization_id: string;
  title?: string;
  summary: string;
  is_featured: boolean;
  display_order: number;
  created_by: string;
  updated_by?: string;
  created_at: string;
  updated_at: string;
  
  // Image details
  image_id?: string;
  image_url?: string;
  image_key?: string;
  original_filename?: string;
  file_size?: number;
  mime_type?: string;
  image_width?: number;
  image_height?: number;
  
  // Organization details
  organization_name?: string;
  created_by_name?: string;
}

export type EntityType = 'lobbyist' | 'charitable_organization' | 'legislator' | 'campaign' | 'client';

export interface CreatePromotionalContentRequest {
  entityType: EntityType;
  entityId: string;
  title?: string;
  summary: string;
  isFeatured?: boolean;
  displayOrder?: number;
  imageFile?: File;
}

export interface UpdatePromotionalContentRequest {
  title?: string;
  summary?: string;
  isFeatured?: boolean;
  displayOrder?: number;
  imageFile?: File;
}

export interface PromotionalContentResponse {
  success: boolean;
  data: PromotionalContent;
  message?: string;
}

export interface PromotionalContentListResponse {
  success: boolean;
  data: {
    promotional_content: PromotionalContent[];
    count: number;
  };
}

export interface OrganizationPromotionalContentResponse {
  success: boolean;
  data: {
    promotional_content: PromotionalContent[];
    pagination: {
      page: number;
      limit: number;
      total: number;
      pages: number;
    };
  };
}

export interface EntityOption {
  id: string;
  name: string;
  type: EntityType;
  hasPromotionalContent?: boolean;
}

export interface ValidationError {
  field: string;
  message: string;
}

export interface PromotionalContentError {
  success: false;
  error: string;
  details?: ValidationError[];
}

// Entity type display configuration
export const ENTITY_TYPE_CONFIG: Record<EntityType, {
  displayName: string;
  pluralName: string;
  icon: string;
  description: string;
}> = {
  lobbyist: {
    displayName: 'Lobbyist',
    pluralName: 'Lobbyists',
    icon: 'Users',
    description: 'Professional lobbyists and advocates'
  },
  charitable_organization: {
    displayName: 'Non-Profit Organization',
    pluralName: 'Non-Profit Organizations', 
    icon: 'Heart',
    description: 'Non-profit organizations and charities'
  },
  legislator: {
    displayName: 'Legislator',
    pluralName: 'Legislators',
    icon: 'Crown',
    description: 'State legislators and representatives'
  },
  campaign: {
    displayName: 'Campaign',
    pluralName: 'Campaigns',
    icon: 'Flag',
    description: 'Political campaigns and committees'
  },
  client: {
    displayName: 'Client',
    pluralName: 'Clients',
    icon: 'Building2',
    description: 'Organizations that hire lobbyists'
  }
};
